import { eventNames, useCoreEvents } from '@carvana/core-events';
import { useContext } from 'react';
import GlobalContext from '~/context/vdp/GlobalContext';

export default function usePageHeaderLoaded() {
  const { setHeaderLoaded } = useContext(GlobalContext);

  useCoreEvents(eventNames.mfer.events, event => {
    if (
      event.eventName === 'react-component' &&
      event.moduleName === 'HeaderModule' &&
      event.data === 'loaded'
    ) {
      setHeaderLoaded(true);
    }
  });
}
